import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegBlobDataTypeEnum } from 'src/app/core/dtos/enum';

@Component({
  selector: 'app-reload-scanned-document',
  templateUrl: './reload-scanned-document.component.html',
  styleUrls: ['./reload-scanned-document.component.scss']
})
export class ReloadScannedDocumentComponent implements OnInit {

  firstFileUploaded = false;
  regId: number;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  public get RegBlobDataTypeEnum() {
    return RegBlobDataTypeEnum;
  }

  ngOnInit(): void {
    this.regId = Number(this.activatedRoute.snapshot.params.regId);
  }

  changeStatus() {
    this.firstFileUploaded = true;
  }

  back() {
    this.router.navigate(['my-account']);
  }

}
